const months = Array(12).fill(0);
const yearStartToCurrent = Array(18).fill(2022);
const dayOfMonths = Array(31).fill(0);


export {months, yearStartToCurrent, dayOfMonths};